const ACTIVE_CLASS = "presentation-active";
const ENTER_REVEAL_CLASS = "presentation-enter-reveal";
const ENTER_UP_CLASS = "presentation-enter-up";
const ENTER_DOWN_CLASS = "presentation-enter-down";
const CONVERSATION_FOCUS_LAYOUT_CLASS = "conversation-focus-layout";
const CONVERSATION_STACK_COLLAPSED_CLASS = "conversation-stack-collapsed";

export function scrubPresentationClasses(className: string | undefined) {
  if (!className) return className;
  const next = className
    .split(/\s+/)
    .filter(
      (name) =>
        name &&
        name !== ACTIVE_CLASS &&
        name !== ENTER_REVEAL_CLASS &&
        name !== ENTER_UP_CLASS &&
        name !== ENTER_DOWN_CLASS &&
        name !== CONVERSATION_FOCUS_LAYOUT_CLASS &&
        name !== CONVERSATION_STACK_COLLAPSED_CLASS,
    )
    .join(" ");
  return next || undefined;
}

export function activePresentationClassName(
  className: string | undefined,
  direction: "up" | "down" | null,
  options: { collapsed?: boolean; reveal?: boolean } = {},
) {
  const names = [scrubPresentationClasses(className), ACTIVE_CLASS];
  if (options.collapsed) names.push(CONVERSATION_STACK_COLLAPSED_CLASS);
  if (options.reveal) names.push(ENTER_REVEAL_CLASS);
  if (direction === "up") names.push(ENTER_UP_CLASS);
  if (direction === "down") names.push(ENTER_DOWN_CLASS);
  return names.filter(Boolean).join(" ");
}
